import React from "react";

function Button({
  text = "Button",
  bgColor = "#00428C",
  textColor = "white",
  fontSize = "text-sm",
  icon = null,
  onClick,
  className = "",
  isLoading = false,
  id = "",
  type = "button",
}) {
  const Icon = icon;

  return (
    <button
      className={`font-poppins ${fontSize} font-semibold leading-5 text-left bg-[${bgColor}] text-${textColor} p-2 rounded-md shadow flex gap-2 justify-center items-center text-center ${className}`}
      onClick={onClick}
      style={{ backgroundColor: bgColor, color: textColor }}
      disabled={isLoading}
      type={type}
      id={id}
    >
      {isLoading ? (
        <div
          className={`spinner-border animate-spin inline-block w-4 h-4 border-4 border-t-4 border-[${textColor}] rounded-full`}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <>
          {icon && <Icon />}
          {text}
        </>
      )}
    </button>
  );
}

export default Button;
